import { Route, Navigate } from 'react-router-dom';
import { SentryRoutes } from '@/lib/sentry';

import Home from '@/pages/Home';
import Author from '@/pages/Author';
import Category from '@/pages/Category';
import Checkout from '@/pages/Checkout';
import Subscribe from '@/pages/Subscribe';
import Purchases from '@/pages/Purchases';
import Admin from '@/pages/Admin';
import Terms from '@/pages/Terms';
import NotFound from '@/pages/NotFound';
import UserAndAuthorTerms from '@/pages/UserAndAuthorTerms';

import ArticleView from '@/components/shared/ArticleView';
import ContactView from '@/components/shared/ContactView';
import { AdminApiProvider } from '@/hooks/useAdminApi';
import ErrorBoundary from '@/routes/ErrorBoundary';
import ProtectedRoutes from '@/routes/ProtectedRoutes';
import PublicRoutes from '@/routes/PublicRoutes';
import LandingView from '@/components/shared/LandingView';

function AppRoutes() {
  return (
    <SentryRoutes>
      {/* Public routes */}
      <Route element={<PublicRoutes />} errorElement={<ErrorBoundary />}>
        <Route path='/terms' element={<Terms />} />
        <Route path='/user-research-provider-terms' element={<UserAndAuthorTerms />} />
      </Route>

      {/* Article needs to have its own rules */}
      <Route path='/article/:id' element={<ArticleView />} errorElement={<ErrorBoundary />} />
      <Route path='/contact' element={<ContactView />} errorElement={<ErrorBoundary />} />
      <Route path='/' element={<LandingView />} errorElement={<ErrorBoundary />} />

      {/* Protected routes */}
      <Route element={<ProtectedRoutes />} errorElement={<ErrorBoundary />}>
        <Route path='/home' element={<Home />} />
        <Route path='/author/:id' element={<Author />} />
        <Route path='/category/:category/:subCategory?/:contentLabel?' element={<Category />} />
        <Route path='/checkout/:id' element={<Checkout />} />
        <Route path='/subscribe' element={<Subscribe />} />
        <Route path='/me/purchases' element={<Purchases />} />
        <Route
          path='/admin'
          element={
            <AdminApiProvider>
              <Admin />
            </AdminApiProvider>
          }
        />
      </Route>

      {/* Error routes */}
      <Route path='/not-found' element={<NotFound />} />
      <Route path='*' element={<Navigate to='/not-found' />} />
    </SentryRoutes>
  );
}

export default AppRoutes;
